export const faqTexts = {
  et: {
    instructions: {
      question: "Kuidas pilli rentida?",
      answer: "Kui näete saadaval sobilikku pilli, looge omale esmalt kasutajakonto, püüdes täita kõik väljad. Seejärel valige pillide nimistust sobiv pill, vajutage nuppu \"Broneeri\". Süsteem broneerib pilli 3 minutiks. \nTutvuge renditingumstega ning nõustuge linnukesega vastavas lahtris. Kui vaikimisi pakutud periood ja arvete saamise sagedus vajavad korrigeerimist, tehke vastavad muudatused. Seejärel vajutage \"Sõlmige rendileping\". Süsteem saadab teile allkirjastamiseks rendilepingu. Saatke see digiallkirjastatuna tagasi. Pärast allkirjastatud lepingu tagasi saatmist kontakteeruge pilli kättesaamiseks."
    },
    tenant_confirmations: {
      question: "Mida peab tegema rentnik lepingu sõlmimisel?",
      answer: "Leping tuleb esmalt saata digiallkirjastatuna tagasi, seejärel e-kirja või telefoni teel kokku leppida üleandmise viis. Pilli kätte saamisel tuleb koheselt tutvuda selle seisukorraga ning vajadusel puudustest teavitada. Rentnik kohustub järgima kasutusjuhiseid."
    },
    agreement_duration: {
      question: "Kui kaua leping kehtib?",
      answer: "Leping kehtib kokkulepitud arvu kuid alates lepingu alguskuupäevast. Leping lõpeb, kui rendiese on täielikult rendileandjale tagastatud ning rendimaksed on tasutud."
    },
    termination: {
      question: "Kuidas saab lepingut varem lõpetada?",
      answer: "Lepingut saab lõpetada poolte kokkuleppel või rendiperioodi lõppemisel. Ennetähtaegsel lõpetamisel tuleb tasuda lisaks kahekordne kuurenditasu."
    },
    rental_fee: {
      question: "Kui suur on renditasu ja millal tuleb maksta?",
      answer: "Renditasu on kuutasu eurodes. Makseid tehakse igakuiselt (kui pole valitud muud maksete intervalli) kindlatel kuupäevadel, alustades esimesest maksepäevast. Soovi korral on võimalik tasuda ka ettemaksuna. Tasu määr sõltub renditavast esemest ja rendiperioodi pikkusest. Populaarseima valiku: 1-aastase rendiperioodi korral on 48-80 bassilise standardbassidega pilli renditasu 23 eurot kuus. Suurema pilli, meloodibassidega pilli või kõlakambriga pilli renditasu on oluliselt kõrgem."
    },
    late_payment: {
      question: "Mis juhtub maksega viivitamisel?",
      answer: "Hilinenud maksetelt arvestatakse viivist 0,5% päevas tasumata summalt kuni täieliku tasumiseni. Rentnik vastutab ka kõigi sissenõudmisega seotud kulude eest."
    },
    billing_method: {
      question: "Mille alusel toimub tasumine?",
      answer: "Rentnik saab automaatseid arveid e-posti teel vastavalt lepingu koostamisel valitud sagedusele. Palume siiski järgida saadud juhiseid ja teha püsikorraldus lepingus toodud viitenumbriga."
    },
    tenant_obligations: {
      question: "Millised on rentniku peamised kohustused?",
      answer: "Rentnik peab kasutama eset hoolikalt ja sihtotstarbeliselt, kaitsma seda kahjustuste ja kaotsimineku eest, teavitama probleemidest ning tagastama eseme rendiperioodi lõpus heas seisukorras. Transpordi- ja tagastamiskulud kannab rentnik."
    },
    issues: {
      question: "Mida teha, kui esemega probleeme tekib?",
      answer: "Kõigi probleemide puhul tuleb e-posti teel teatada rendileandjale. Vajadusel saab eseme remontimiseks tagastada või uue eseme saada. Eseme parandamise või asendamise kulud kannab rendileandja, välja arvatud juhul, kui probleem on tekkinud rentniku hooletuse või väärkasutuse tõttu. Ka väiksemate probleemide korral tuleb enne ise korda seadmist konsulteerida rendileandjaga."
    },
    lessor_obligations: {
      question: "Millised on rendileandja kohustused?",
      answer: "Rendileandja kohustub andma rendieseme üle heas töökorras ning olema kättesaadav mõistlikele küsimustele ja muredele."
    },
    liability: {
      question: "Kes vastutab kahju või kaotsimineku eest?",
      answer: "Rentnik vastutab hooletuse või väärkasutuse tõttu tekkinud kahju eest. Varguse või täieliku kaotsimineku korral tuleb hüvitada eseme asenduskulu."
    },
    maintenance_rules: {
      question: "Kuidas tuleb rendieset hoida, kasutada ja hooldada?",
      answer: "Instrumenti tuleb hoida kuivas keskkonnas, käsitseda ettevaatlikult, puhastada pehme lapiga ning vältida omavolilisi parandusi. Transportimisel peab ese olema korralikult kaitstud."
    },
    payment_instructions: {
      question: "Kuidas toimub tasumine?",
      answer: "Renditasu tasutakse igakuiselt rendileandja pangakontole. Soovitatav on kasutada püsikorraldust koos viitenumbriga."
    },

    return: {
      question: "Kuidas toimub tagastamine?",
      answer: "Tagastamiseks tuleb eseme tagastada algses seisukorras. Kui eseme seisukord on halvem kui hoolsast tavapärasest kasutamisest tulenev muutus, võib tagastamisel koguda lisatasu. Puhastage instrument ja kast enne tagastamist ning veenduge, et rihmad on kaasas. Kontakteeruge rendileandjaga tagastamise aja ja koha osas. Vaikimisi on tagastamise koht rendileandja aadress Sombre tee 58, Suurupi, Harjumaa."
    },
    extension_automatic: {
      question: "Kas rendileping pikeneb automaatselt?",
      answer:
        "Jah. Kui rendiakordion ei ole tagastatud lepingu lõppkuupäevaks, pikendatakse kehtivat rendilepingut automaatselt sama pikkuse perioodi võrra, mis oli märgitud kehtivas lepingus."
    },
    no_return_by_end_date: {
      question: "Mis juhtub, kui tagastamise tähtaeg möödub ja instrumenti ei ole tagastatud?",
      answer:
        "Kui instrumenti ei ole tagastatud lepingu lõppkuupäevaks, loetakse see rendiperioodi pikendamiseks ning leping pikeneb automaatselt. Renditasu arvestus jätkub vastavalt kehtiva lepingu tingimustele."
    },
    need_new_contract_for_extension: {
      question: "Kas lepingu pikendamiseks on vaja sõlmida uus leping?",
      answer:
        "Ei. Kui rendiperiood pikeneb samadel tingimustel ja sama pikkuse perioodi võrra, ei ole uue lepingu sõlmimine vajalik."
    },
    notify_extension_intent: {
      question: "Kas pikendamise soovist tuleb rendileandjat teavitada?",
      answer:
        "Jah. Kuigi leping pikeneb automaatselt, palume segaduste vältimiseks teavitada pikendamise soovist e-posti teel."
    },
    different_extension_period: {
      question: "Mis saab siis, kui soovin pikendada lepingut teistsuguse perioodi võrra?",
      answer:
        "Kui soovite pikendada rendilepingut varasemast erineva pikkusega perioodiks, tuleb sõlmida uus rendileping. Sellisel juhul võib kuurenditasu erineda ning vajalik on ka uue püsikorralduse seadistamine uue viitenumbriga."
    },
    return_deadline: {
      question: "Millal tuleb instrument tagastada, kui soovin lepingu lõpetada?",
      answer:
        "Lepingu lõpetamiseks peab rendiakordion olema tagastatud ja üle antud lepingu lõppkuupäevaks. Tagastamise aja ja viisi kokkuleppimiseks tuleb eelnevalt rendileandjaga ühendust võtta."
    },
    contact: {
      question: "Kuidas rendileandjaga ühendust võtta?",
      answer: "Rendileandjaga saab ühendust võtta e-posti teel või telefonil. E-posti aadress on info@akordion.ee ja telefon on +372 5022771."
    }
  },

  en: {
    instructions: {
        question: "How to rent an instrument?",
        answer: "If you see a suitable instrument available, first create a user account. Then select the desired instrument from the list and click the \"Reserve\" button. The system will hold the instrument for 3 minutes. Review the rental terms and confirm by checking the box. If the default rental period or invoice frequency needs adjustment, make the necessary changes. Then click \"Sign the Rental Agreement.\" The system will send you the agreement to sign. Return it digitally signed. After sending back the signed agreement, contactto arrange instrument pickup."
        },
    

    tenant_confirmations: {
      question: "What must the tenant do when signing the agreement?",
      answer: "The agreement must first be returned digitally signed, then the method of handover should be agreed via email or phone. Upon receiving the instrument, the tenant must immediately inspect its condition and report any defects. The tenant must follow the usage instructions."
    },
    agreement_duration: {
      question: "How long is the agreement valid?",
      answer: "The agreement is valid for the agreed number of months from the start date. It ends when the rented item has been fully returned and all rental payments have been made."
    },
    termination: {
      question: "How can the agreement be terminated early?",
      answer: "The agreement can be terminated by mutual consent, at the end of the rental period, or when the item is returned in good condition. Early termination requires payment of double the monthly rental fee."
    },
    rental_fee: {
      question: "What is the rental fee and when must it be paid?",
      answer: "The rental fee is a fixed monthly amount in euros. Payments are made monthly on agreed dates, starting from the first payment date. Advance payments are possible. The fee depends on the item and rental period. Example: for a 1-year rental of a standard 48-80 bass instrument, the fee is 23 euros/month. Larger instruments, melody basses, or instruments with resonance chambers have higher fees."
    },
    late_payment: {
      question: "What happens in case of late payment?",
      answer: "A late fee of 0.5% per day is charged on the unpaid amount until full payment is made. The tenant is also responsible for all costs related to debt collection."
    },
    billing_method: {
      question: "How is billing handled?",
      answer: "Invoices are sent by email according to the chosen frequency in the agreement. Please follow the instructions and set up a standing order with the reference number indicated in the agreement."
    },
    tenant_obligations: {
      question: "What are the tenant’s main obligations?",
      answer: "The tenant must use the item carefully and as intended, protect it from damage or loss, report issues, and return it in good condition at the end of the rental period. The tenant covers transport and return costs."
    },
    issues: {
      question: "What to do if problems occur with the item?",
      answer: "The tenant must inform by email in all cases. If necessary, the item can be returned for repair or replaced. Repair or replacement costs are borne by the lessor, except if the problem was caused by tenant negligence or misuse. Even for minor issues, consult the lessor before attempting repairs yourself."
    },
    lessor_obligations: {
      question: "What are the lessor’s obligations?",
      answer: "The lessor must provide the rented item in good working condition and be available to answer reasonable questions or concerns."
    },
    liability: {
      question: "Who is responsible for damage or loss?",
      answer: "The tenant is responsible for damage caused by negligence or misuse. In case of theft or total loss, the tenant must compensate the replacement cost of the item."
    },
    maintenance_rules: {
      question: "How should the rented item be stored, used and maintained?",
      answer: "The instrument must be kept in a dry environment, handled carefully, cleaned with a soft cloth, and not modified without permission. Proper protection is required during transport."
    },
    payment_instructions: {
      question: "How is payment made?",
      answer: "The rental fee is paid monthly to the lessor’s bank account. A standing order with a reference number is recommended."
    },
    return: {
      question: "How is the item returned?",
      answer: "The item must be returned in its original condition. If the condition is worse than normal wear and tear, extra fees may apply. Clean the instrument and case before return and ensure straps are included. Contact the lessor to arrange time and place. Default return location is the lessor’s address: Sombre tee 58, Suurupi, Harju maakond."
    },
    extension_automatic: {
      question: "Is the rental agreement extended automatically?",
      answer:
        "Yes. If the rented accordion is not returned by the agreement end date, the rental agreement is automatically extended for the same period length as specified in the current agreement."
    },
    no_return_by_end_date: {
      question: "What happens if the end date passes and the instrument is not returned?",
      answer:
        "If the instrument is not returned by the agreement end date, this is considered an extension of the rental period and the agreement will be automatically extended. Rental fee billing will continue according to the existing agreement."
    },
    need_new_contract_for_extension: {
      question: "Is a new contract required to extend the agreement?",
      answer:
        "No. If the agreement is extended under the same terms and for the same period length, signing a new contract is not required."
    },
    notify_extension_intent: {
      question: "Do I need to inform the if I want to extend the agreement?",
      answer:
        "Yes. Although the agreement is extended automatically, we kindly ask you to notify of your intention to extend the rental by email to avoid misunderstandings."
    },
    different_extension_period: {
      question: "What if I want to extend the agreement for a different period length?",
      answer:
        "If you wish to extend the rental agreement for a period of a different length than the current one, a new rental agreement must be signed. In this case, the monthly rental fee may differ and a new standing order with a new reference number is required."
    },
    return_deadline: {
      question: "When must the instrument be returned if I want to end the agreement?",
      answer:
        "To terminate the agreement, the rented accordion must be returned and handed over before the agreement end date. Please contact  in advance to arrange the return time and method."
    },
    
    contact: {
    question: "How to contact?",
    answer: "You can contact by email or phone. The email address is info@akordion.ee and the phone number is +372 5022771."
    }
  }
};

export const faqTexts2 = {
  et: {
    faq: "Korduma kippuvad küsimused",
  },

  en: {
    faq: "Frequently Asked Questions",
  }
};
